import { Avatar, Stack, Typography } from "@mui/material";
import { convertToFullName } from "../../services/utils";
import { useAppSelector } from "../../store";

export function ProfileAvatar({
  item,
  nameField = "firstName",
  size,
  sx = {},
  withFullName = false,
  onClick,
  showCompanyName,
}: any) {
  const { data } = useAppSelector((state) => state.profile);

  const avatarObj = item || data;

  const src = item
    ? showCompanyName
      ? avatarObj?.photo || avatarObj?.picture
      : null
    : avatarObj?.picture;
  const initial = item ? avatarObj?.[nameField]?.[0] : avatarObj?.firstName[0];

  if (withFullName) {
    const fullName = item
      ? avatarObj?.[nameField]
      : convertToFullName(avatarObj);

    return (
      <Stack
        direction={"row"}
        display="flex"
        alignItems={"center"}
        gap={1}
        onClick={() => onClick && onClick(item)}
        sx={{
          cursor: onClick && "pointer",
        }}
      >
        <Avatar
          variant={size}
          sx={{
            bgcolor: "secondary.main",
            ...sx,
          }}
          src={src}
        >
          {initial}
        </Avatar>
        <Typography>{fullName}</Typography>
      </Stack>
    );
  }

  return (
    <Avatar
      variant={size}
      sx={{
        bgcolor: "secondary.main",
        ...sx,
      }}
      src={src}
    >
      {initial}
    </Avatar>
  );
}
